import { LoadedInfoState, IPlaylistData } from './State'

export const TOGGLE_IS_LOADING = 'enterprisePlaylistComponent.toggleIsLoading'
export const SET_PLAYLIST_DATA = 'enterprisePlaylistComponent.setPlaylistData'
export const SET_INFO_LOADED_STATE = 'enterprisePlaylistComponent.setInfoLoadedState'
export const RESET = 'enterprisePlaylistComponent.reset'

export function toggleIsLoading() {
  return {
    type: TOGGLE_IS_LOADING,
    payload: {}
  } as const
}

export function setPlaylistData(payload: IPlaylistData, infoState: LoadedInfoState) {
  return {
    type: SET_PLAYLIST_DATA,
    payload: {
      data: payload,
      infoState
    }
  } as const
}

export function setInfoLoadedState(payload: LoadedInfoState) {
  return {
    type: SET_INFO_LOADED_STATE,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type EnterprisePlaylistAction = ReturnType<
  typeof toggleIsLoading | typeof setPlaylistData | typeof reset | typeof setInfoLoadedState
>
